import { z } from 'zod';
import {
    CardPointeCredentialResolutionOutcome,
    type CardPointeCredentialResolutionNormalizedResult,
    type CardPointeCredentialResolutionRequest,
    type CardPointeCredentialResolutionResponse,
} from '../../../types/ipg/cardpointe/cardpointe-credential-resolution.types';
import { CardPointeThirdPartySystemId } from '../../../types/ipg/cardpointe/cardpointe-system-constants';
import {
    CardPointeCredentialsPublicSchema,
    CardPointeCredentialsSchema,
    CardPointeCredentialsSecretSchema,
} from './cardpointe-credential.schemas';

export const CardPointeCredentialResolutionRequestSchema: z.ZodObject<{
    systemId: z.ZodLiteral<typeof CardPointeThirdPartySystemId>;
    publicCredentials: typeof CardPointeCredentialsPublicSchema;
    secretCredentials: typeof CardPointeCredentialsSecretSchema;
    credentialUuid: z.ZodOptional<z.ZodString>;
}> = z.object({
    systemId: z.literal(CardPointeThirdPartySystemId),
    publicCredentials: CardPointeCredentialsPublicSchema,
    secretCredentials: CardPointeCredentialsSecretSchema,
    credentialUuid: z.string().uuid().optional(),
}) satisfies z.ZodType<CardPointeCredentialResolutionRequest>;

export const CardPointeCredentialResolutionNormalizedResultSchema: z.ZodObject<{
    credentials: typeof CardPointeCredentialsSchema;
}> = z.object({
    credentials: CardPointeCredentialsSchema,
}) satisfies z.ZodType<CardPointeCredentialResolutionNormalizedResult>;

export const CardPointeCredentialResolutionResolvedResponseSchema: z.ZodObject<{
    outcome: z.ZodLiteral<typeof CardPointeCredentialResolutionOutcome.RESOLVED>;
    normalizedResult: typeof CardPointeCredentialResolutionNormalizedResultSchema;
}> = z.object({
    outcome: z.literal(CardPointeCredentialResolutionOutcome.RESOLVED),
    normalizedResult: CardPointeCredentialResolutionNormalizedResultSchema,
});

export const CardPointeCredentialResolutionInvalidResponseSchema: z.ZodObject<{
    outcome: z.ZodLiteral<typeof CardPointeCredentialResolutionOutcome.INVALID_CREDENTIALS>;
    message: z.ZodString;
}> = z.object({
    outcome: z.literal(CardPointeCredentialResolutionOutcome.INVALID_CREDENTIALS),
    message: z.string().min(1),
});

export const CardPointeCredentialResolutionResponseSchema: z.ZodType<CardPointeCredentialResolutionResponse> =
    z.discriminatedUnion('outcome', [
        CardPointeCredentialResolutionResolvedResponseSchema,
        CardPointeCredentialResolutionInvalidResponseSchema,
    ]);
